import { Box, IconButton, Typography, Grid } from "@material-ui/core";
import { DataGrid } from "@mui/x-data-grid";

import CloseIcon from "@material-ui/icons/Close";
import { setVisitorsOrigin } from "store/appSlice";
import { useDispatch, useSelector } from "react-redux";
import { VISITORS_LAYER_ID } from "components/layers/VisitorsLayer";
import { updateLayer, setViewState } from "@carto/react-redux";
import { VISITORS_ORIGINS_LAYER_ID } from "components/layers/VisitorsOriginsLayer";
import { makeStyles } from "@material-ui/core/styles";
import { VISITORS_DESTINATION_LAYER_ID } from "components/layers/VisitorsDestinationLayer";
import { WrapperWidgetUI } from "@carto/react-ui";
import { initialState } from "store/initialStateSlice";

export default function WidgetsPanel() {
  const useStyles = makeStyles((theme) => ({
    dataTable: {
      fontSize: 10,
      height: 210,
      width: 225,
    },
    wrapperLeft: {
      "& .makeStyles-root-29 h6": {
        textAlign: "right",
      },
    },
    spreadBox: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    visitorsComponent: {
      position: "absolute",
      backgroundColor: theme.palette.background.paper,
      right: theme.spacing(3),
      top: theme.spacing(3),
      boxShadow: theme.shadows[1],
      borderRadius: 4,
    },
  }));
  const classes = useStyles();
  const dispatch = useDispatch();
  const visitorsOrigin = useSelector((state) => state.app.visitorsOrigin);
  const dataOrigins = useSelector((state) => state.app.dataOrigins);
  const day = useSelector((state) => state.app.day);
  const window = useSelector((state) => state.app.window);

  const handleButton = () => {
    dispatch(
      setViewState({
        latitude: initialState.viewState.latitude,
        longitude: initialState.viewState.longitude,
        zoom: initialState.viewState.zoom,
        hasFlight: true,
      })
    );
  };

  function handleRowClick(e) {
    dispatch(
      setViewState({
        latitude: e.lat,
        longitude: e.long,
        zoom: 13,
        hasFlight: true,
      })
    );
  }
  function handleVisualization() {
    handleButton();
    dispatch(setVisitorsOrigin(null));
    dispatch(
      updateLayer({
        id: VISITORS_ORIGINS_LAYER_ID,
        layerAttributes: {
          visible: false,
        },
      })
    );
    dispatch(
      updateLayer({
        id: VISITORS_LAYER_ID,
        layerAttributes: {
          visible: true,
        },
      })
    );
    dispatch(
      updateLayer({
        id: VISITORS_DESTINATION_LAYER_ID,
        layerAttributes: {
          visible: false,
        },
      })
    );
  }

  var columns = [
    {
      field: "distance",
      headerName: "Distance",
      align: "center",
      flex: 1,
      minWidth: 75,
      description: "Distance to the seleceted grid in KMs",
      headerAlign: "center",
    },
    {
      field: "n_visitors",
      headerName: "Visitors",
      align: "center",
      flex: 1,
      minWidth: 75,
      description: "Number of unique visitors coming from the area",
      headerAlign: "center",
    },
  ];

  return (
    visitorsOrigin &&
    dataOrigins && (
      <Grid className={classes.visitorsComponent}>
        <WrapperWidgetUI
          title="Visitors origins"
          className={classes.wrapperLeft}
        >
          <Box className={classes.spreadBox}>
            <Typography variant="overline">
              Quadkey: {`${visitorsOrigin}`}{" "}
            </Typography>
            <IconButton onClick={handleVisualization}>
              <CloseIcon />
            </IconButton>
          </Box>
          <DataGrid
            className={classes.dataTable}
            headerHeight={25}
            rowHeight={25}
            align={"center"}
            disableColumnMenu={true}
            rows={dataOrigins.features
              .filter((obj) => obj.properties.part_of_day === window)
              .filter((obj) => obj.properties.day_of_week === day)
              .filter(
                (obj) => obj.properties.geo_id_destination === visitorsOrigin
              )
              .map((e) => e.properties)}
            columns={columns}
            pageSize={5}
            hideFooterSelectedRowCount
            sortingOrder={["desc", "asc"]}
            onRowClick={(rowData) => handleRowClick(rowData.row)}
          />
        </WrapperWidgetUI>
      </Grid>
    )
  );
}
